export enum ActionTimesQuota {
  Over55 = 'over55',
}
